import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const BASE_KEY = "teams";
const ACCOUNT_USERS_QUERY_KEY = "accountUsers";
const MY_TEAMS_QUERY_KEY = "mine";

export const teamsQueryKeys = {
    all: () => [BASE_KEY] as const,
    myTeams: () => [BASE_KEY, MY_TEAMS_QUERY_KEY] as const,
    accountUsers: () => [BASE_KEY, ACCOUNT_USERS_QUERY_KEY] as const,
} as const satisfies QueryKeyFactory;
